import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiCheckCircle } = FiIcons;

function RevealScreen({ label, title, description, quote, onContinue }) {
  return (
    <motion.main
      className="reveal-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <motion.div
        className="reveal-card"
        initial={{ y: 24, scale: 0.97 }}
        animate={{ y: 0, scale: 1 }}
      >
        <SafeIcon icon={FiCheckCircle} className="reveal-icon" />
        <span className="eyebrow">{label}</span>
        <h2>{title}</h2>
        <p>{description}</p>
        <blockquote>「{quote}」</blockquote>
        <button className="primary-button" type="button" onClick={onContinue}>
          繼續試煉
          <SafeIcon icon={FiArrowRight} />
        </button>
      </motion.div>
    </motion.main>
  );
}

export default RevealScreen;